// Registrazione minimale del service worker (Fase 1).
export function registerServiceWorker() {
  if ("serviceWorker" in navigator) {
    window.addEventListener("load", () => {
      navigator.serviceWorker
        .register("/service-worker.js")
        .catch((err) => console.warn("SW registration failed:", err));
    });
  }
}
